@if (isMobile()) {
    <app-mobile-projection
        [loading]="loading"
        [report]="report"
        [company]="company"
        [accordionState]="accordionState"
        (handleChangePeriod)="onChangePeriod($event)"
        (handleChangeComparation)="onChangeComparation($event)"
        (handleResetPeriod)="onResetPeriod()"
        [previewMode]="previewMode"
    ></app-mobile-projection>
} @else {
    <app-desktop-projection
        [loading]="loading"
        [accordionState]="accordionState"
        [report]="report"
        [company]="company"
        (handleChangePeriod)="onChangePeriod($event)"
        (handleChangeComparation)="onChangeComparation($event)"
        (handleResetPeriod)="onResetPeriod()"
        [previewMode]="previewMode"
    ></app-desktop-projection>
}
